<template>
  <div class="relative h-[calc(100vh-4rem)] md:h-screen">
    <AnimatedList class="justify-evenly" v-if="contactStore.contact.length > 0">
      <IdCardContactComponent v-for="message of contactStore.contact" :key="message.uuid" :message="message"/>
    </AnimatedList>

    <TitreUn v-if="contactStore.contact.length === 0" :content='t("noMessage")'
             class="absolute left-1/2 top-1/2 translate-x-[-50%] translate-y-[-50%]"/>
  </div>
</template>

<script setup>

import IdCardContactComponent from "@/components/organismes/IdCardContactComponent.vue";
import {ContactStores} from "@/stores/ContactStore";
import {UtilisateurStores} from "@/stores/UtilisateurStores";
import {router} from "@/routeur";
import {NotificationStores} from "@/stores/NotificationStores";
import {enumeration} from "../../Enumeration";
import {t} from "@/utils/Traduction";
import TitreUn from "@/components/atoms/TitreUn.vue";
import AnimatedList from "@/components/molecules/AnimatedList.vue";

const utilisateurStore = UtilisateurStores();
const notificationStores = NotificationStores();

if(utilisateurStore.role !== enumeration.role.ADMIN) {
  utilisateurStore.logout(false);
  notificationStores.addNotification(t("youNeedToBeAdminToAccessThisPage"), 'error');
  router.push({ path: "/" });
}

const contactStore = ContactStores();

if(contactStore.contact.length === 0) {
  contactStore.loadContacts();
}

</script>

<style scoped>

</style>